module.exports = {
  profile: "Profile",
  myAccount: "Account",
  myInvoice: "Invoice",
  myCoupon: "Coupon"
}


// WEBPACK FOOTER //
// ./src/pages/home/i18n/locale.en.js